import { X } from "lucide-react";

export interface CrossButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const CrossButton: React.FC<CrossButtonProps> = ({ onClick,disabled }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="absolute right-4 top-4 rounded-sm text-[#0A0A0A] hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
    aria-label="Cross button"
  >
    <X className="h-3.5 w-3.5" style={{ strokeWidth: 2 }} />
  </button>
);
